const API_URL = 'https://api.partbay.ai';

export default API_URL;
